export enum QRFormat {
  PNG = 'png',
  SVG = 'svg',
}
